export default class StatusScore {
    constructor(statusId) {
        this._statusId = statusId;
    }

    get statusId() {
        return this._statusId;
    }

    get headerLpKey() {
        return `scoring.${this._statusId}.header`;
    }

    get titleLpKey() {
        return `scoring.${this._statusId}.title`;
    }

    get descriptionLpKey() {
        return `scoring.${this._statusId}.description`;
    }
}
